/**
 * Pdf portal
 * Portal to generate PDF and handle authentication.
 *
 * OpenAPI spec version: 1.0.32
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

/**
 * * `bool` - Bool * `text` - Text * `option` - Option
 */
export type QuestionTypeEnum = 'bool' | 'text' | 'option';

export const QuestionTypeEnum = {
    Bool: 'bool' as QuestionTypeEnum,
    Text: 'text' as QuestionTypeEnum,
    Option: 'option' as QuestionTypeEnum
};